import { useEffect, useState } from "react";
import { cashManager } from "../../data/managers/CashManager";
import { CashModel } from "../../data/models/cash/CashModel";
import { useLoading } from "../../data/providers/LoadingProvider";
import { useSnackbar } from "../../data/providers/SnackbarProvider";

export const useCash = () => {
  const { showSnackbar, showError } = useSnackbar();
  const { startLoading, stopLoading, loading } = useLoading();

  useEffect(() => {
    refreshCashes();
  }, []);

  const [cashes, setCashes] = useState<CashModel[]>([]);

  const refreshCashes = async () => {
    try {
      startLoading();
      const resp = await cashManager.getAllCashes();
      if (!resp) {
        showError("No se pudieron cargar las cajas");
        return;
      }
      setCashes(resp.map((p: any) => new CashModel(p)));
    } catch (err) {
      showError("Error al obtener las cajas");
    } finally {
      stopLoading();
    }
  };

  const createCash = async (data: Omit<CashModel, "id">) => {
    try {
      startLoading();
      const cash: CashModel = {
        ...data,
      };
      const r = await cashManager.updateOrCreateCash(cash);
      if (!r) throw new Error("On create cash");
      showSnackbar("Caja creada exitosamente");
    } catch (err) {
      showError("No se pudo crear la caja");
    } finally {
      await refreshCashes();
      stopLoading();
    }
  };

  const openCashAndRedirect = async (cash: CashModel) => {
    try {
      startLoading();
      const r = await cashManager.updateOrCreateCash(cash);
      if (!r) throw new Error("On create cash");
      showSnackbar("Caja abierta exitosamente");
    } catch (err) {
      showError("No se pudo abrir la caja");
    } finally {
      await refreshCashes();
      stopLoading();
    }
  };

  return {
    cashes,
    createCash,
    openCashAndRedirect,
    loading,
  };
};
